<template>
<div style="margin-top: 20px;">
  <loading :active.sync="isLoading"
    :can-cancel="true"
    color="#5bad2b"
    :is-full-page="fullPage"></loading>
  <div v-show="intestpoput" class="modal fade in" id="modal-default" style="display: block; padding-right: 17px;">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <span data-dismiss="modal" @click="close()" class="pop-up-close-icon"><i aria-hidden="true" class="uil uil-times"></i></span>
                <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true" @click="close()">×</span></button> -->
                <h4 class="modal-title">Select Date & time</h4>
              </div>
              <div class="modal-body">
                <div class="row mt-2 tc" v-if="groupeddate.length < 1">
                  No availability dates found!
                </div>
                <b-form class="register-form">
                  <div class="row mt-2" v-if="groupeddate.length > 0">
                      Select date
                      <hr>
                  </div>
                  <div class="row">
                      <ul class="donate-now mt-0">
                        <li v-for="date in groupeddate" @click="changeDate(date.startdate)" :key="date">
                          <input type="radio" :id="date._id" name="date" />
                          <label :for="date._id">{{date.startdate}} <br> {{date.startday}}</label>
                        </li>
                      </ul>
                  </div>
                  <div class="row mt-2" v-if="showtime">
                      Select time
                      <hr>
                  </div>
                  <div class="row" v-if="showtime">
                      <ul class="donate-now mt-0">
                        <li v-for="date in availabletime" :key="date" style="width: 136px;height: 33px;" @click="getdatetime(date.start_datetime,date.end_datetime)">
                          <input type="radio" :id="date.start_datetime" name="time" />
                          <label :for="date.start_datetime">{{date.start_time}} - {{date.end_time}}</label>
                        </li>
                      </ul>
                  </div>
                <div v-if="validationerror" class="scroll-to-me mt-1" style="color:red;margin-left: -10px;">* Please select availability time</div>
              </b-form>
              </div>
              <div class="modal-footer">
                <button :disabled="groupeddate.length < 1" v-if="actiontype ==1" type="button" @click="interestRequest(1)"  class="btn btn-success"><i class="uil uil-thumbs-up" aria-hidden="true"></i> Interest</button>
                <button :disabled="groupeddate.length < 1" v-if="actiontype ==2" type="button" @click="interestRequest(2)"  class="btn btn-success"><i class="fa fa-check" aria-hidden="true"></i> Accept</button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <div v-show="Boolean(showconfirm)" class="modal fade in" id="modal-default" style="display: block; padding-right: 17px;">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body">
                <h5 style="font-weight: 600;">Uninterest Confirmation</h5>
                <hr>
                <div style="text-align:center;margin-top: 30px;">Are you sure you want to cancel this profile?</div>
              </div>
              <div class="modal-footer" style="border-top-color: #ffffff;">
                <button type="button" @click="close()"  class="btn btn-default"> No</button>
                <button type="button" @click="uninterestRequest(profileid)"  class="btn btn-success"> Yes</button>

              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
  <!-- intrest availability modal end -->
      <div class="col-md-12" style="margin-top:20px">
          <!-- Custom Tabs -->
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li class="active" v-on:click="navigation('Post')"><a href="#tab_1" data-toggle="tab">Post</a></li>
              <li v-on:click="navigation('To-be-Scheduled')"><a href="#tab_2" data-toggle="tab">To-be Scheduled</a></li>
              <li v-on:click="navigation('Scheduled')"><a href="#tab_3" data-toggle="tab">Scheduled</a></li>
              <li v-on:click="navigation('Result')"><a href="#tab_4" data-toggle="tab">Result</a></li>
            </ul>
            <div class="tab-content" style="margin-bottom: 43px;">
              <div class="tab-pane active" id="tab_1">
              <div class="col-md-6 remove-pad">
                <div class="box box-primary">
                  <div class="box-header with-border">
                    <h3 class="box-title">Post</h3>
                  </div>
                  <div class="box-header with-border">
                    <input v-model="postsearch" @keyup="getDatas()" type="text" class="form-control pull-left search-text" placeholder="Search" style="width:50%;height: 20% !important;">
                    <div style="width:50%;" class="pull-right">
                      <div class="form-group">
                        <div class="form-select pull-right" style="width: 50%;">
                          <select @change="getDatas()" v-model="postsort" class="form-control input-sm">
                            <option value="7">Last 7 days</option>
                            <option value="0">Last 30 days</option>
                          </select>
                          <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                        </div>
                      </div>
                      <span class="pull-right ml-1">Sort by</span>
                    </div>
                  </div>
                  <!-- /.box-header -->
                  <div class="box-body">
                    <!-- <div style="margin-top:30px;text-align:center" v-if="datas.length < 1"> No data found</div>         -->
                    <div style="text-align:center; margin-top:75px" v-if="datas.length < 1">
                      <img src="../../assets/img/post_empty.svg" alt="Product Image" style="width: 150px;">
                      <br>
                      <span style="font-size: 12px;color: black;">No data found</span>
                    </div>
                    <!-- <button v-if="datas.length < 1" type="button" class="btn btn-block post-empty btn-flat btn-sm">Create post now!</button> -->
                    <addpost v-if="datas.length < 1"></addpost>
                    <ul class="products-list product-list-in-box overff">
                       <li class="item" v-for="x in datas" :key="x._id" @click="getPostdata(x._id,x)" v-bind:class="{'active': selectpost === x._id}">
                         <div class="row">
                         <div class="col-md-5 p-1">
                           <div class="product-img">
                            <img v-if="x.profile_picture !='' && x.profile_picture !=null" :src="`${x.profile_picture}`" class="img-circle">
                            <img v-if="x.profile_picture =='' || x.profile_picture ==null" src="../../assets/img/org-default.png" class="img-circle">
                            <img v-if="x.post_expired =='true'" src="../../assets/img/expired.png" class="img-circle exp-imgmt-2" style=" width: 10px !important;margin-left: -11px;margin-top: 25px;height: 10px !important;">
                          </div>
                          <div class="product-info">
                            <a href="javascript:void(0)" class="product-title"><span :title="x.job_title" class="overflow">{{x.job_tittle}} <img v-if="x.notification_count > 0" src="../../assets/img/green_dot.svg" class="img-circle"></span>
                            </a>
                            <span class="product-description" :title="x.post_unique_id"><span class="skill-lable" v-if="showRole">{{x.post_unique_id}} - {{x.bull_horn_number}}</span><span class="skill-lable" v-if="!showRole">{{x.post_unique_id}}</span></span>
                          </div>
                         </div>
                         <div class="col-md-7 p-1">
                            <div class="pull-right showdate">
                              <span class="ml-1">Posted on : {{x.created_at | formatDate}}</span>
                              <!-- <span>Validity : {{x.post_validity | formatDate}}</span> -->
                            </div>
                          </div>
                         </div>
                         <div class="row">
                          <div class="col-md-5 p-1">
                            <div class="ml-5 mt-2">
                            <span class="product-description" :title="x.primaryskillnames"><span class="skill-lable">Skills : </span>
                              {{x.primaryskillnames}}
                            </span>
                          </div>
                          </div>
                          <div class="col-md-7 p-1">
                            <div class="pull-right">
                              <div class="btn-group" v-if="!showRole" >
                                <button type="button" class="btn bg-full btn-sm"><i class="uil uil-thumbs-up" aria-hidden="true"></i> Interest</button>
                                <button type="button" class="btn btn-default btn-sm b-c">{{x.interest_count}}</button>
                              </div>
                              <div class="btn-group mr-1">
                                <button type="button" class="btn bg-full btn-sm"><i class="uil uil-calender" aria-hidden="true"></i> Scheduled</button>
                                <button type="button" class="btn btn-default btn-sm b-c ml-1">{{x.schedule_count}}</button>
                              </div>
                            </div>
                          </div>
                         </div>
                        </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-6 remove-pad">
                <div class="box box-primary">
                  <div class="box-header with-border" v-if="datas.length > 0 && job_title">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="direct-chat-msg">
                          <div class="clearfix">
                            <span class="direct-chat-name pull-left"><span :title="job_title" class="overflow">{{job_title}}</span></span>
                          </div>
                          <span class="direct-chat-timestamp pull-left">{{post_unique_id}} <span class="ml-20" v-if="post_expired =='true'"><img src="../../assets/img/expired.png" class="img-circle exp-img" style="width: 13px !important;margin-top:2px;height: 13px !important;"> <span class="expired">Expired</span></span></span>
                          <span class="direct-chat-timestamp pull-left over-len" :title="job_skills">Skills : <span style="color:black"> {{job_skills}}</span></span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="direct-chat-msg">
                          <div class="clearfix">
                            <span class="direct-chat-timestamp pull-right"><button class="btn btn-default btns"><i class="fa fa-bookmark" aria-hidden="true"></i> View Bookmark</button></span>
                          </div>
                          <span class="direct-chat-name pull-right"></span>
                          <span class="direct-chat-timestamp pull-right mt-2">Validity : {{job_validity | formatDate}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="posttab mt-2">
                      <ul class="nav nav-tabs post">
                        <li v-if="!showRole" v-bind:class="{'active': posttabThree}" @click="posttabOne = false, posttabTwo = false, posttabThree = true, posttabFour = false, posttabFive = false"><a href="#tab_p1" data-toggle="tab">Post</a></li>
                        <li class="acsli" v-if="showRole" v-bind:class="{'active': posttabThree}" @click="posttabOne = false, posttabTwo = false, posttabThree = true, posttabFour = false, posttabFive = false"><a href="#tab_p1" data-toggle="tab">Post</a></li>
                        <li class="acsli" v-if="showRole" v-bind:class="{'active': posttabOne}" @click="posttabOne = true, posttabTwo = false, posttabThree = false, posttabFour = false, tabFive = false"><a href="#tab_p2" data-toggle="tab">Panelists</a></li>
                        <li v-if="!showRole" v-bind:class="{'active': posttabOne}" @click="posttabOne = true, posttabTwo = false, posttabThree = false, posttabFour = false, tabFive = false"><a href="#tab_p2" data-toggle="tab">Relevant Profiles</a></li>
                        <li v-if="!showRole" v-bind:class="{'active': posttabTwo}" @click="posttabOne = false, posttabTwo = true, posttabThree = false, posttabFour = false, tabFive = false, checkcounts()"><a href="#tab_p3" data-toggle="tab"><span class="label label-success int-badg pull-right" v-if="interest_count > 0">{{interest_count}}</span>Interested</a></li>
                        <!-- <li v-bind:class="{'active': posttabThree}" @click="posttabOne = false, posttabTwo = false, posttabThree = true, posttabFour = false, posttabFive = false, bothshedule()"><a href="#tab_p4" data-toggle="tab">To-be Scheduled</a></li> -->
                        <!-- <li v-bind:class="{'active': posttabFour}" @click="posttabOne = false, posttabTwo = false, posttabThree = false, posttabFour = true, posttabFive = false, sheduleddata()"><a href="#tab_p5" data-toggle="tab">Schedule</a></li> -->
                      </ul>
                    </div>
                    <div v-if="posttabTwo" style="margin-top: 5px;">
                      <div class="column is-full" v-if="Boolean(showfiletersend)">
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                          <label class="btn btn-success mr-2" @click="getInterestsend(selectpost)">
                            <i class="fa fa-check-square" aria-hidden="true"></i>
                            <input type="radio" name="options" id="option1" autocomplete="off" checked><span class="label label-success int-badg pull-right" v-if="send_interest_count > 0">{{send_interest_count}}</span> Sent
                          </label>
                          <label @click="getInterest(selectpost)" class="btn" style="background-color: #f6f6f6;border: 1px solid #ccc;">
                            <i class="fa fa-square-o" aria-hidden="true"></i>
                            <input type="radio" name="options" id="option2" autocomplete="off"><span class="label label-success int-badg pull-right" v-if="receive_interest_count > 0">{{receive_interest_count}}</span> Receive
                          </label>
                        </div>
                      </div>
                      <div class="column is-full" v-if="Boolean(showfileterreceive)">
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                          <label @click="getInterestsend(selectpost)" class="btn ml-0 mr-2" style="background-color: #f6f6f6;border: 1px solid #ccc;">
                            <i class="fa fa-square-o" aria-hidden="true"></i>
                            <input type="radio" name="options" id="option1" autocomplete="off" checked><span class="label label-success int-badg pull-right" v-if="send_interest_count > 0">{{send_interest_count}}</span> Sent
                          </label>
                          <label class="btn btn-success" @click="getInterest(selectpost)">
                            <i class="fa fa-check-square" aria-hidden="true"></i>
                            <input type="radio" name="options" id="option2" autocomplete="off"><span class="label label-success int-badg pull-right" v-if="receive_interest_count > 0">{{receive_interest_count}}</span> Received
                          </label>
                        </div>
                      </div>
                      <div class="column is-full" v-if="Boolean(showfileterreceivesend)">
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                          <label @click="getInterestsend(selectpost)" class="btn ml-0 mr-2" style="background-color: #f6f6f6;border: 1px solid #ccc;">
                            <i class="fa fa-square-o" aria-hidden="true"></i>
                            <input type="radio" name="options" id="option1" autocomplete="off" checked><span class="label label-success int-badg pull-right" v-if="send_interest_count > 0">{{send_interest_count}}</span> Sent
                          </label>
                          <label @click="getInterest(selectpost)" class="btn" style="background-color: #f6f6f6;border: 1px solid #ccc;">
                            <i class="fa fa-square-o" aria-hidden="true"></i>
                            <input type="radio" name="options" id="option2" autocomplete="off"><span class="label label-success int-badg pull-right" v-if="receive_interest_count > 0">{{receive_interest_count}}</span> Receive
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                <div v-if="posttabThree">
                  <div class="card-body" v-if="job_title">
                  <b-form class="register-form" id="resets" v-on:submit.prevent="onSubmitProfile" novalidate>
                    <div class="col-md-12">
                      <!-- <button v-if="editoption1" @click="changeedit()" style="width: 93px;height: 30px;" class="btn btn-success pull-right">Edit</button> -->
                      <input v-if="Boolean(editoption2)" type="submit" value="Save" style="width: 93px;height: 30px;" class="submit pull-right" name="submit" id="submit" />
                      <button :disabled="!Boolean(enableeditpost)" v-if="Boolean(editoption1)" @click="changeedit()" style="width: 93px;height: 30px;font-size: 16px;padding: 2px;" class="btn btn-success pull-right">Edit</button>
                      <div v-if="Boolean(editoption2)"><button @click="cancel()" style="width: 93px;height: 30px;font-size: 16px;padding: 2px;" class="btn btn-default pull-right mr-2">Cancel</button></div>
                    </div>
                      <div class="row mt-2">
                      <div class="col-md-12 mt-2" v-if="showRole">
                        <div class="form-row">
                          <div class="form-group">
                            <label>ATS Number</label>
                            <b-form-input v-model.lazy.trim="bull_horn_number" type="text" disabled="disabled" />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-2" v-if="showRole">
                        <label>Business Unit</label>
                        <div class="form-row">
                          <div class="form-group">
                            <div class="form-select">
                              <select :disabled="Boolean(editoption)" v-model="form.businessunit_id" class="form-control" v-bind:class="{ 'is-invalid': !chkState('year_of_experience') }">
                                <option value='' disabled>Business unit *</option>
                                <option v-for="unit in businessunitlist" v-bind:value="unit._id" :key="unit">{{unit.name}}</option>
                              </select>
                              <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2" v-if="isclient =='yes' || isclient =='Yes'">
                          <div class="col-md-6">
                            <label>Client Name</label>
                            <b-form-input v-model.lazy.trim="$v.form.companyName.$model" type="text" disabled="disabled" />
                          </div>
                          <div class="col-md-6">
                            <label>Client Email</label>
                            <b-form-input :disabled="Boolean(editoption)" type="text" v-model.lazy.trim="$v.form.client_emailid.$model" placeholder="Client Email*" />
                            <div v-if="$v.form.client_emailid.$error">
                              <p v-if="!$v.form.client_emailid.required" class="login-alert-msg error-content">* Enter client email ID</p>
                              <p v-if="!$v.form.client_emailid.email" class="login-alert-msg error-content">* Enter valid client email ID</p>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12 mt-2" v-if="isclient =='yes' || isclient =='Yes'" v-show="quessclient">
                      <label for="">Department Name</label>
                          <div class="form-row">
                            <div class="form-group">
                              <div class="form-select">
                                <select :disabled="Boolean(editoption)" v-model="form.dept_name" class="form-control" v-bind:class="{ 'is-invalid': !chkState('dept_name') }">
                      <option value="" class="text" disabled
                            >Select Department*</option>
                          <option>QSR</option>
                          <option>QITS</option>
                    </select>
                    <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                              </div>
                              <div v-if="$v.form.dept_name.$error">
                    <p v-if="!$v.form.dept_name.required" class="login-alert-msg error-content">*Select Department Name</p>
                  </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <label>Title</label>
                          <b-form-input type="text" v-model.lazy.trim="$v.form.job_tittle.$model" disabled="disabled" placeholder="Job Title*" />
                        </div>
                        <div class="col-md-12 mt-2">
                          <label>Validity</label>
                          <span class="date select-icon" style="height: 40px;margin-top: 23px;"><i class="uil uil-calender"></i></span>
                          <datetime :disabled="Boolean(editoption)" v-model.lazy.trim="$v.form.post_validity.$model" format="dd-MMM-yyyy" :min-datetime="minDatetime1" value-zone="Asia/Tokyo" zone="Asia/Tokyo" type="date" placeholder="Select Validity *">
                          </datetime>
                          <div v-if="$v.form.post_validity.$error">
                            <p v-if="!$v.form.post_validity.required" class="login-alert-msg error-content">* Select post validity</p>
                          </div>
                        </div>
                        <div class="col-md-12 mt-2">
                          <label>Overall Experience</label>
                          <div class="form-row">
                            <div class="form-group">
                              <div class="form-select">
                                <select :disabled="Boolean(editoption)" @change="updateyear()" v-model="form.year_of_experience" class="form-control" v-bind:class="{ 'is-invalid': !chkState('year_of_experience') }">
                                  <option value='' disabled>Select Year *</option>
                                  <option value="1">1 year</option>
                                  <option v-for="x in 19" v-bind:value="x +1" :key="x">{{x + 1}} years</option>
                                </select>
                                <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                              </div>
                              <div v-if="$v.form.year_of_experience.$error">
                                <p v-if="!$v.form.year_of_experience.required" class="login-alert-msg error-content">* Select the year</p>
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="form-select">
                                <select :disabled="Boolean(editoption)" id="month" v-model="form.month_of_experience" class="form-control" v-bind:class="{ 'is-invalid': !chkState('month_of_experience') }">
                                  <option value='' disabled>Select Month *</option>
                                  <option value="0">0 month</option>
                                  <option value="1">1 month</option>
                                  <option v-for="x in 10" v-bind:value="x +1" :key="x">{{x + 1}} months</option>
                                </select>
                                <span for="month" class="select-icon"><i class="fa fa-chevron-down"></i></span>
                              </div>
                              <div v-if="$v.form.month_of_experience.$error">
                                <p v-if="!$v.form.month_of_experience.required" class="login-alert-msg error-content">* Select the month</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-select">
                            <label v-if="!showRole">Primary Skills</label>
                            <label v-if="showRole">Required Technical Skills</label>
                            <multiselect :disabled="Boolean(editoption)" :hide-selected="true" :show-labels="false" class="drop-multi-select" name="skills" v-model="form.primarySkils" v-bind:class="{ 'is-invalid': !chkState('primarySkils') }" placeholder="Select Skills*" label="name" track-by="name" :options="pSkils" :group-select="true" :multiple="true" @input="add()"></multiselect>
                          </div>
                        </div>
                          <div class="mb-2 col-md-12 mt-2" v-for="(input,k) in showpskills" :key="k">
                          <div class="input-group input-group-sm">
                            <div class="input-group-prepend" style="width: 40%;">
                              <span :title="input.name" class="input-group-text over-len newdesign" style="width: 100%; text-align:left;border-radius: 0px;">{{input.name}}</span>
                            </div>
                            <input type="hidden" v-model="input.skill_id">
                            <input type="hidden" v-model="input.skill_name">
                            <select :disabled="Boolean(editoption)" :id="input.skill_name" @click="removeerrorp()" v-model="input.year_of_experience" class="form-control exp-group">
                              <option v-for="x in topyear" v-bind:value="x" :key="x">{{x}}</option>
                              <option value='' disabled>Year *</option>
                            </select>
                            <select :disabled="Boolean(editoption)" @click="removeerrorp()" v-model="input.month_of_experience" class="form-control exp-group">
                              <option value='' disabled>Month *</option>
                              <option value='0'>0</option>
                              <option v-for="x in 11" v-bind:value="x" :key="x">{{x}}</option>
                            </select>
                            <!-- <input type="number" @click="removeerrorp()" v-model="input.year_of_experience" class="form-control exp-group" placeholder="year" min="0" :max="form.year_of_experience"> -->
                            <!-- <input type="number" @click="removeerrorp()" v-model="input.month_of_experience" class="form-control exp-group" placeholder="month" min="0" :max="form.month_of_experience"> -->
                          </div>
                          </div>
                          <div id="ps" class="mb-2 col-md-12 mt-2" v-for="(input,k) in inputs" :key="k">
                          <div class="input-group input-group-sm">
                            <div class="input-group-prepend" style="width: 40%;">
                              <span :title="input.skill_name" class="input-group-text over-len newdesign" style="width: 100%; text-align:left;border-radius: 0px;">{{input.skill_name}}</span>
                            </div>
                            <input type="hidden" v-model="input.skill_id">
                            <input type="hidden" v-model="input.skill_name">
                            <select :id="input.skill_name" @click="removeerrorp()" v-model="input.year_of_experience" class="form-control exp-group">
                              <option v-for="x in topyear" v-bind:value="x" :key="x">{{x}}</option>
                              <option value='' disabled>Year *</option>
                            </select>
                            <select @click="removeerrorp()" v-model="input.month_of_experience" class="form-control exp-group">
                              <option value='' disabled>Month *</option>
                              <option value='0'>0</option>
                              <option v-for="x in 11" v-bind:value="x" :key="x">{{x}}</option>
                            </select>
                            <!-- <input type="number" @click="removeerrorp()" v-model="input.year_of_experience" class="form-control exp-group" placeholder="year" min="0" :max="form.year_of_experience"> -->
                            <!-- <input type="number" @click="removeerrorp()" v-model="input.month_of_experience" class="form-control exp-group" placeholder="month" min="0" :max="form.month_of_experience"> -->
                            <p v-if="pskillerror" class="login-alert-msg error-content">* Select the primary skills years and month</p>
                          </div>
                          </div>
                        <div class="col-md-12 mt-2">
                          <div class="form-select">
                            <label v-if="!Boolean(showRole)">Secondary Skills</label>
                            <label v-if="Boolean(showRole)">Preferred Technical Skills</label>
                            <multiselect :disabled="Boolean(editoption)" :hide-selected="true" :show-labels="false" class="drop-multi-select" name="skills" v-model="form.secoundarySkills" v-bind:class="{ 'is-invalid': !chkState('secoundarySkills') }" placeholder="Select Skills*" label="name" track-by="name" :options="sSkils" :group-select="true" :multiple="true" @input="addsecondaryskill()"></multiselect>
                          </div>
                        </div>
                        <div class="col-md-12 mt-2">
                            <div class="mb-2 col-md-12 mt-2 p-1" v-for="(input,k) in showsskills" :key="k">
                          <div class="input-group input-group-sm">
                            <div class="input-group-prepend" style="width: 40%;">
                              <span :title="input.name" class="input-group-text over-len newdesign" style="width: 100%; text-align:left;border-radius: 0px;">{{input.name}}</span>
                            </div>
                            <input type="hidden" v-model="input.skill_id">
                            <input type="hidden" v-model="input.skill_name">
                            <select :disabled="Boolean(editoption)" :id="input.skill_name" @click="removeerrorp()" v-model="input.year_of_experience" class="form-control exp-group">
                              <option v-for="x in topyear" v-bind:value="x" :key="x">{{x}}</option>
                              <option value='' disabled>Year *</option>
                            </select>
                            <select :disabled="Boolean(editoption)" @click="removeerrorp()" v-model="input.month_of_experience" class="form-control exp-group">
                              <option value='' disabled>Month *</option>
                              <option value='0'>0</option>
                              <option v-for="x in 11" v-bind:value="x" :key="x">{{x}}</option>
                            </select>
                            <!-- <input type="number" @click="removeerrorp()" v-model="input.year_of_experience" class="form-control exp-group" placeholder="year" min="0" :max="form.year_of_experience"> -->
                            <!-- <input type="number" @click="removeerrorp()" v-model="input.month_of_experience" class="form-control exp-group" placeholder="month" min="0" :max="form.month_of_experience"> -->
                          </div>
                          </div>
                          <div style="margin-bottom: -6px;" class="box box-success scroll" v-if="form.secoundarySkills.length > 0">
                            <div class="mb-2" v-for="(inputs,i) in secondaryinputs" :key="i">
                            <div class="input-group input-group-sm">
                              <div class="input-group-prepend" style="width: 40%;">
                                <span :title="inputs.skill_name" class="input-group-text over-len newdesign" style="width: 100%;text-align:left;border-radius: 0px;">{{inputs.skill_name}}</span>
                              </div>
                              <input type="hidden" v-model="inputs.skill_id">
                              <input type="hidden" v-model="inputs.skill_name">
                              <select @click="removeerrorp()" v-model="inputs.year_of_experience" class="form-control exp-group">
                                <option v-for="x in topyear" v-bind:value="x" :key="x">{{x}}</option>
                                <option value='' disabled>Year *</option>
                              </select>
                              <select @click="removeerrorp()" v-model="inputs.month_of_experience" class="form-control exp-group">
                                <option value='' disabled>Month *</option>
                                <option value='0'>0</option>
                                <option v-for="x in 11" v-bind:value="x" :key="x">{{x}}</option>
                              </select>
                              <!-- <input type="number" @click="removeerrors()" v-model="inputs.year_of_experience" class="form-control exp-group" placeholder="year" min="0" :max="form.year_of_experience"> -->
                              <!-- <input type="number" @click="removeerrors()" v-model="inputs.month_of_experience" class="form-control exp-group" placeholder="month" min="0" :max="form.month_of_experience"> -->
                            </div>
                          </div>
                            <p v-if="Sskillerror && !showRole" class="login-alert-msg error-content">* Select the secondary skills years and month</p>
                            <p v-if="Sskillerror && showRole" class="login-alert-msg error-content">* Select the preferred technical skills years and month</p>
                            </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-row" v-if="showRole">
                            <div class="form-group" style="width:100%">
                              <label>Additional Skills</label>
                              <b-form-input v-model="otherEmails" :disabled="Boolean(editoption)" style="width:90%;float: left;" type="text" required placeholder="Enter skill name"/>
                              <button :disabled="Boolean(editoption)" style="float:right;height: 40px;" type="button" @click="enterEmail()" class="btn btn-success">Add</button>
                            </div>
                          </div>
                          <div class="form-row" v-if="showRole">
                            <div class="form-group">
                              <label v-if="otheremailList.length > 0">Additional Skills Experience</label>
                              <div style="margin-bottom: -6px;" class="box box-success scroll" v-if="otheremailList.length > 0">
                              <div class="mb-2" v-for="(item,i) in otheremailList" :key="i">
                                  <div class="input-group input-group-sm">
                                  <div class="input-group-prepend" style="height: 32px;">
                                    <span :title="item.skill_name" class="input-group-text over-len" style="width: 40%; text-align:left;border-radius: 0px;">{{item.skill_name}}</span>
                                    <select :id="item.skill_name" @click="removeerror_other()" style="height: 32px !important;" v-model="item.year_of_experience" class="form-control exp-group">
                                      <option v-for="x in topyear" v-bind:value="x" :key="x">{{x}}</option>
                                      <option value='' disabled>Year *</option>
                                    </select>
                                    <select @click="removeerror_other()" style="height: 32px !important;" v-model="item.month_of_experience" class="form-control exp-group">
                                      <option value='' disabled>Month *</option>
                                      <option value='0'>0</option>
                                      <option v-for="x in 11" v-bind:value="x" :key="x">{{x}}</option>
                                    </select>
                                    <span @click="removeEmail(i)" style="color: rgb(221, 75, 57);height: 32px;width: 25px;
                    margin-top: 1px;
                    padding: 6px;
                    background-color: #f0f3f5;">X</span>
                                  </div>
                                </div>
                                </div>
                              </div>
                              <div v-if="other_pskillerror">
                                <p class="login-alert-msg error-content">* Select Additional Skills Experience</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12 mt-2">
                          <label>Interview Type</label>
                          <div class="form-row">
                            <div class="interview-type form-group" @click="post_type_of_interview('video')" v-bind:class="{'post_interview-type': form.job_interview_type === 'video'}">
                              <span><i class="uil uil-video" aria-hidden="true"></i> Video</span>
                            </div>
                            <div class="interview-type form-group" @click="post_type_of_interview('audio')" v-bind:class="{'post_interview-type': form.job_interview_type === 'audio'}">
                              <span><i class="uil uil-microphone" aria-hidden="true"></i> Audio</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12 mt-2">
                          <label>Attachment</label>
                          <div class="custom-file-upload" :disabled="Boolean(editoption)">
                            <div v-if="files.length < 1" class="show-doc-empty">Select the File </div>
                            <div class="show-doc" v-if="files.length > 0">
                              <span :disabled="Boolean(editoption)" class="doc-file pull-left" v-for="x in files.slice(0, 2)" :key="x"><span class="doc-name">{{x.name}} </span><i @click="removeUploading1(x)" v-if="!Boolean(editoption)" class="fa fa-times" style="color: #ccc;" aria-hidden="true"></i></span>
                            </div>
                            <label :disabled="Boolean(editoption)" for="filess"><i class="uil uil-upload" aria-hidden="true"></i> Upload </label>
                            <input :disabled="Boolean(editoption)" @change="fileUploadss($event)" style="visibility: hidden;" type="file" id="filess" name="myfiles1[]"/>
                        </div>
                        <p style="color: #aeaaaa;margin: 3px 0 10px;">Supported format (.pdf, .doc, .docx), Size (Max 2MB)</p>
                        </div>
                        <div class="col-md-12 mt-2">
                          <label>Job Description</label>
                          <b-form-textarea :disabled="Boolean(editoption)" @keyup="changedesc()" v-model.lazy.trim="$v.form.org_description.$model" :state="chkState('org_description')" class="textarea" rows="3" placeholder="Enter Job Description"></b-form-textarea>
                          <div>
                            <p class="login-alert-msg error-content mb-1" style="color: #b1abaa !important">{{desclength}} characters left</p>
                          </div>
                          <div v-if="$v.form.org_description.$error">
                            <p v-if="!$v.form.org_description.required" class="login-alert-msg error-content">* Enter the job description</p>
                            <p v-if="!$v.form.org_description.maxLength" class="login-alert-msg error-content">* Job description can be max 2000 characters long</p>
                          </div>
                        </div>
                        <div class="col-md-12 mt-2">
                          <label>Remarks</label>
                          <b-form-textarea :disabled="Boolean(editoption)" @keyup="changeremarks()" v-model.lazy.trim="$v.form.job_comments.$model" :state="chkState('job_comments')" class="textarea" rows="3" placeholder="Enter Remarks"></b-form-textarea>
                          <div>
                            <p class="login-alert-msg error-content mb-1" style="color:#b1abaa !important">{{remarklength}} characters left</p>
                          </div>
                          <div v-if="$v.form.job_comments.$error">
                            <!-- <p v-if="!$v.form.job_comments.required" class="login-alert-msg error-content">* Enter the remarks</p> -->
                            <p v-if="!$v.form.job_comments.maxLength" class="login-alert-msg error-content">* Remarks can be max 600 characters long</p>
                          </div>
                        </div>
                      </div>
                  </b-form>
                  </div>
                </div>
                  <!-- Relevent Profiles -->
                  <div style="margin-top: 50%;text-align:center" v-if="releventprofiles.length < 1 && posttabOne">
                    <img src="../../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">

                  </div>
                  <!-- card comp -->
                  <CardView v-if="posttabOne" @interestRequest="interestRequestEmit" :postprofile="true" :data="releventprofiles" :showRole="showRole" :selectpost="selectpost"></CardView>
                  <!-- <div class="box-body" v-if="posttabOne">
                    <ul class="products-list product-list-in-box overff" v-bind:class="{'active': posttabOne}">
                       <li class="item" v-for="(x, index) in releventprofiles" :key="index">
                          <div class="row">
                          <div class="col-md-5">
                            <div class="product-img">
                              <img @click="showModal(x._id)" v-if="x.profile_picture !='' && x.profile_picture !=null" :src="`${x.profile_picture}`" class="img-circle">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == null" src="../../assets/img/default.png" class="img-circle">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Female'" src="../../assets/img/female_default.png" class="img-circle">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Male'" src="../../assets/img/male_default.png" class="img-circle">
                            </div>
                            <div class="product-info">
                              <a href="javascript:void(0)" @click="showModal(x._id)" class="product-title name">{{x.first_name}} {{x.last_name}}
                              </a>
                              <span class="product-description" :title="x.primaryskillnames"><span class="skill-lable">Designation : </span>
                                  {{x.designation}}
                              </span>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <button v-if="!showRole" class="btn btn-default btn-xs btns pull-left ml8"><i class="uil uil-rupee-sign"></i>{{x.interview_cost}} / Interview</button>
                          </div>
                          <div class="col-md-3">
                            <span class="direct-chat-timestamp f12" style="width:25%">Rating  <star-rating class="pull-right" style="width:60%" :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="15" :rating="Number(x.interviewer_rating)" :read-only="Boolean('true')"></star-rating></span>
                          </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-md-6">
                              <span class="product-description ml-5" :title="x.userskillnames"><span class="skill-lable">Skillset : </span>
                              {{x.userskillnames}}
                            </span>
                            </div>
                            <div class="col-md-3">
                              <span class="direct-chat-timestamp mt-2 wishlist pull-right"><a class="tc"><i class="fa fa-bookmark" aria-hidden="true"></i> Bookmark</a></span>
                            </div>
                            <div class="col-md-3 tc myseek">
                            <label for="" v-if="showRole">{{x.availability_req_status}}</label>
                              <button v-if="showRole" data-toggle="modal" data-target="#seekTime" @click="submitRequest(index, x._id)" class="btn btn-primary btn-sm pull-right"><i class="uil uil-clock" aria-hidden="true"></i> Seek Time </button>
                              <button v-if="showRole && x.availability_tag == 'yes'" @click="showShedule(x._id)" class="btn btn-success btn-sm pull-right"><i class="uil uil-thumbs-up" aria-hidden="true"></i> Schedule</button>
                              <button v-if="showRole && x.availability_tag == 'no' && x.send_availability_mail == 'yes'" disabled class="btn btn-success btn-sm pull-right"><i class="uil uil-thumbs-up" aria-hidden="true"></i> Schedule</button>
                              <button v-if="!showRole" @click="interestRequest(x._id, 1)" class="btn btn-success btn-sm pull-right"><i class="uil uil-thumbs-up" aria-hidden="true"></i> Interest</button>
                            </div>
                            <div></div>
                          </div>
                        </li>
                    </ul>
                  </div> -->
                  <!-- Interested Profiles -->
                  <div v-if="posttabTwo" v-bind:class="{'active': posttabTwo}">
                    <div style="margin-top: 50%;text-align:center" v-if="interestedlength < 1 && Boolean(showfileterreceive)">
                        <img src="../../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">
                    </div>
                    <div style="margin-top: 50%;text-align:center" v-if="interestedsendlength < 1 && Boolean(showfiletersend)">
                        <img src="../../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">
                    </div>
                    <CardView v-if="Boolean(showfileterreceive)" @interestRequest="interestRequestEmit" :showRole="showRole" :interestRec="true" :data="interested" :selectpost="selectpost"></CardView>
                    <!-- <div class="box-body" v-if="Boolean(showfileterreceive)">
                    <ul class="products-list product-list-in-box overff">
                       <li class="item" v-for="x in interested" :key="x._id">
                          <div class="row">
                          <div class="col-md-5">
                            <div class="product-img">
                              <img @click="showModal(x._id)" v-if="x.profile_picture !='' && x.profile_picture !=null" :src="`${x.profile_picture}`" class="img-circle">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == null" src="../../assets/img/default.png" class="img-circle">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Female'" src="../../assets/img/female_default.png" class="img-circle">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Male'" src="../../assets/img/male_default.png" class="img-circle">
                            </div>
                            <div class="product-info">
                              <a href="javascript:void(0)" @click="showModal(x._id)" class="product-title name">{{x.first_name}} {{x.last_name}}
                              </a>
                              <span class="product-description" :title="x.interviewer_interest_date | formatDatetimea"><span class="skill-lable">Applied on : </span>
                                {{x.interviewer_interest_date | formatDatetimea }}
                              </span>
                            </div>
                          </div>
                          <div class="col-md-4" @click="showSheduledetails(x._id,x.statusval)">
                            <button class="btn btn-default btn-xs btns pull-left ml8"><i class="uil uil-rupee-sign"></i>{{x.interview_cost}} / Interview</button>
                          </div>
                          <div class="col-md-3" @click="showSheduledetails(x._id,x.statusval)">
                            <span class="direct-chat-timestamp f12" style="width:25%">Rating  <star-rating class="pull-right" style="width:60%" :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="15" :rating="Number(x.interviewer_rating)" read-only="true"></star-rating></span>
                          </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-md-5" @click="showSheduledetails(x._id,x.statusval)">
                              <span class="product-description ml-5" :title="x.userskillnames"><span class="skill-lable">Skillset : </span>
                              {{x.userskillnames}}
                            </span>
                            </div>
                            <div class="col-md-2 p-1">
                              <span class="direct-chat-timestamp mt-2 wishlist pull-right"><a><i class="fa fa-bookmark" aria-hidden="true"></i> Bookmark</a></span>
                            </div>
                            <div class="col-md-3 mt-2 p-1">
                              <a @click="showReason(x._id)" v-if="x.statusval !='Declined' && x.status !='Accepted' && x.statusval !='cancelled'" class="direct-chat-timestamp pull-right" style="color:red;cursor: pointer;"><i class="fa fa-times" aria-hidden="true"></i> Decline</a>
                            </div>
                            <div class="col-md-2 p-1">
                              <a v-if="x.status =='Accept' && (x.statusval =='' || x.statusval ==null)" class="button btn-align sbtn btn-sm accent-btn rounded raised pull-right" @click="interestRequest(x._id, 2)"><i class="fa fa-check" aria-hidden="true"></i>Accept</a>
                              <span v-if="x.status =='Accepted' && (x.statusval =='' || x.statusval ==null)" class="pull-right" style="color:#5bad2b"><i class="fa fa-check" aria-hidden="true"></i> Accepted</span>
                              <span @click="showSheduledetails(x._id,x.statusval)" v-if="x.statusval =='Declined'" class="pull-right" style="color:#ff2627"> Declined</span>
                              <span @click="showSheduledetails(x._id,x.statusval)" v-if="x.statusval =='cancelled'" class="pull-right" style="color:#ff2627">Cancelled</span>
                            </div>
                          </div>
                        </li>
                    </ul>
                    </div> -->
                    <CardView v-if="Boolean(showfiletersend) && interestedsendlength > 0" @uninterestRequest="uninterestRequestEmit" :showRole="showRole" :interestSend="true" :data="interestedsend" :selectpost="selectpost"></CardView>
                    <!-- <div class="box-body" v-if="Boolean(showfiletersend) && interestedsendlength > 0">
                      <ul class="products-list product-list-in-box overff">
                        <li class="item" v-for="x in interestedsend" :key="x._id">
                          <div class="row">
                          <div class="col-md-5">
                            <div class="product-img">
                              <img @click="showModal(x._id)" v-if="x.profile_picture !='' && x.profile_picture !=null" :src="`${x.profile_picture}`" class="img-circle">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == null" src="../../assets/img/default.png" class="img-circle">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Female'" src="../../assets/img/female_default.png" class="img-circle">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Male'" src="../../assets/img/male_default.png" class="img-circle">
                            </div>
                            <div class="product-info">
                              <a href="javascript:void(0)" @click="showModal(x._id)" class="product-title">{{x.first_name}} {{x.last_name}}
                              </a>
                              <span class="product-description" :title="x.org_interest_date | formatDatetimea"><span class="skill-lable">Interested on : </span>
                                {{x.org_interest_date | formatDatetimea }}
                              </span>
                            </div>
                          </div>
                          <div class="col-md-4" @click="showSheduledetails(x._id,x.statusval)">
                            <button class="btn btn-default btn-xs btns pull-left ml8"><i class="uil uil-rupee-sign"></i>{{x.interview_cost}} / Interview</button>
                          </div>
                          <div class="col-md-3" @click="showSheduledetails(x._id,x.statusval)">
                            <span class="direct-chat-timestamp f12" style="width:25%">Rating  <star-rating class="pull-right" style="width:60%" :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="15" :rating="Number(x.interviewer_rating)" read-only="true"></star-rating></span>
                          </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-md-5" @click="showSheduledetails(x._id,x.statusval)">
                              <span class="product-description ml-5" :title="x.userskillnames"><span class="skill-lable">Skillset : </span>
                              {{x.userskillnames}}
                            </span>
                            </div>
                            <div class="col-md-4">
                              <span class="direct-chat-timestamp ml-1 wishlist" style="width: 28%;"><a><i class="fa fa-bookmark" aria-hidden="true"></i> Bookmark</a></span>
                            </div>
                            <div class="col-md-3 tc">
                              <span @click="showSheduledetails(x._id,x.statusval)" v-if="x.status =='Accepted' && (x.statusval =='' || x.statusval ==null)" class="pull-right" style="color:#5bad2b"><i class="fa fa-check" aria-hidden="true"></i> Accepted</span>
                              <span @click="showSheduledetails(x._id,x.statusval)" v-if="x.statusval =='Declined'" class="pull-right" style="color:#ff2627">Declined</span>
                              <span @click="showSheduledetails(x._id,x.statusval)" v-if="x.statusval =='cancelled'" class="pull-right" style="color:#ff2627"> Cancelled</span>
                              <button v-if="x.status =='uninterest' && (x.statusval =='' || x.statusval ==null)" @click="showconfirmation(x._id)" class="btn btn-success btn-sm pull-right"><i class="fa fa-thumbs-o-down" aria-hidden="true"></i> Uninterest</button>
                            </div>
                          </div>
                        </li>
                    </ul>
                  </div> -->
                  </div>
                   <!-- Modal for short intro -->
<div class="modal fade" id="seekTime" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title closebtnmodel" id="exampleModalLabel"><strong>Seek Time Request</strong> <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button></h4>
      </div>
      <div class="modal-body txtarea">
        <label for="">Remarks*</label>
        <textarea  placeholder="Enter the remarks" class="invalid-feedback" name="" id="" cols="100" rows="5" v-model="comments"></textarea>
        <span style="color:red">{{remarkAlert}}</span>
        <!-- <div
                  v-if=" $v.comments.$error"
                  class="invalid-feedback" style="color:red; font-size:12px;text-align:left;"
                >
                  <span v-if="!$v.comments.required"
                    >seek time response is required</span
                  > -->
                  <!-- <span v-if="$v.comments.required && !$v.comments"
                    >Short Intro must be at least 50 characters</span
                  > -->
                <!-- </div> -->
      </div>
      <!-- <p style="float:right;padding:4px">Max 200 Characters</p> -->
      <br>
      <div class="modal-footer introBtn">
        <button type="button" class="btn " data-dismiss="modal">Close</button>
        <button type="button" class="btn saveaccdetialsbtn"  v-on:click="seekTime()">Submit</button>
      </div>
    </div>
  </div>
</div>
                </div>
              </div>
              </div>
              <!-- /.tab-pane -->
            </div>
            <!-- /.tab-content -->
          </div>
          <!-- nav-tabs-custom -->
          <profile-modal v-model="modalOpen" v-if="modalOpen"></profile-modal>
          <add-shedule v-model="shwovalue" :shwovalueAddSchedule="shwovalue" v-if="shwovalue"></add-shedule>
          <schedule-details v-model="sheduledetailsOpen" v-if="sheduledetailsOpen"></schedule-details>
          <reason-popup v-model="reasonOpen" v-if="reasonOpen"></reason-popup>
          <div id="callstop" @click="relotab()"></div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import router from '../../router/index'
import ProfileModal from '../Feature/profileDetails'
import ReasonPopup from '../Feature/reasonpopup'
import AddShedule from '../Feature/addshedule'
import ScheduleDetails from '../Feature/interestdetail'
// import StarRating from 'vue-star-rating'
import Vue from 'vue'
import addpost from '../Feature/addpost_dashboard'
import Multiselect from 'vue-multiselect'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'
import moment from 'moment'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CardView from '../Feature/cardView'

import $ from 'jquery'
Vue.use(moment)
export const EventBus = new Vue()
const formShape = {
  job_tittle: '',
  year_of_experience: '',
  month_of_experience: '',
  post_validity: '',
  primarySkils: '',
  secoundarySkills: '',
  job_interview_type: 'video',
  job_description_template: '',
  org_description: '',
  job_comments: '',
  client_emailid: '',
  companyName: '',
  dept_name: '',
  businessunit_id: '',
  comments: ''
}
const clickHandler = function (userid) {
  // console.log(`Oh, that's nice. It's gotten ${userid} clicks! :)`)
}
// Listen to the event.
EventBus.$on('i-got-clicked', clickHandler)

export default {
  data () {
    return {
      viewid: [],
      pSkils: [],
      sSkils: [],
      inputs: [],
      postdetails: [],
      secondaryinputs: [],
      showsskills: [],
      showpskills: [],
      job_title: '',
      client_emailid: '',
      client_name: '',
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      job_skills: '',
      post_unique_id: '',
      post_expired: false,
      job_validity: '',
      job_postedon: '',
      interestedsend: [],
      interestedsendlength: 0,
      productsShow: 20,
      datas: [],
      files: [],
      releventprofiles: [],
      interested: [],
      interestedlength: 0,
      postdatas: [],
      bothinterest: [],
      bothinterestlength: 0,
      availabledate: [],
      groupeddate: [],
      desclength: 2000,
      remarklength: 600,
      availabletime: [],
      getshedule: [],
      getshedulelength: 0,
      sheduledatas: [],
      reasonList: [],
      selecttimedetais: [],
      startdatetime: '',
      enddatetime: '',
      selectdate: '',
      mainurl: '',
      base_urls: BaseURL,
      postsearch: '',
      postsort: 0,
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      tabOne: false,
      tabTwo: false,
      tabThree: false,
      tabFour: false,
      tabFive: false,
      tabSix: false,
      posttabOne: true,
      posttabTwo: false,
      posttabThree: false,
      editoption1: true,
      editoption2: false,
      editoption: true,
      posttabFour: false,
      posttabFive: false,
      showfiletersend: true,
      showfileterreceive: false,
      selectpost: '',
      modalOpen: false,
      shwovalue: false,
      sheduledetailsOpen: false,
      reasonOpen: false,
      intestpoput: false,
      intestpoputre: false,
      showconfirm: false,
      validationerror: false,
      validationerrorre: false,
      pvalidation: 0,
      pskillerror: false,
      Sskillerror: false,
      showtime: false,
      isLoading: true,
      fullPage: true,
      businessunitlist: false,
      enableeditpost: false,
      businessunitlength: 0,
      profileid: '',
      actiontype: '',
      selectdata: JSON.parse(localStorage.getItem('postId')),
      form: Object.assign({}, formShape),
      interest_count: 0,
      receive_interest_count: 0,
      send_interest_count: 0,
      showfileterreceivesend: false,
      minDatetime1: '',
      imageupload: 0,
      dirty_form: true,
      showRole: false,
      isclient: 'no',
      quessclient: false,
      otheremailList: [],
      otherEmails: '',
      bull_horn_number: '',
      remarkAlert: '',
      seekindex: '',
      comments: ''
    }
  },
  components: {
    ProfileModal, AddShedule, ReasonPopup, ScheduleDetails, addpost, Multiselect, Loading, CardView
  },
  created () {
    this.tabOne = true
    this.querytype = this.$route.query.type
    this.getreasondata()
    // console.log(this.$route.query.type)
    var d = new Date()
    var day = this.addZero(d.getDate())
    var month = this.addZero(d.getMonth() + 1)
    var year = this.addZero(d.getFullYear())
    this.minDatetime1 = year + '-' + month + '-' + day
    // console.log('cc')
    // console.log(this.minDatetime1)
    this.$root.$emit('navigate', 'Post')
    // window.addEventListener('beforeunload', function (e) {
    //   $('#callstop').click()
    //   console.log(e)
    //   e.preventDefault() // If you prevent default behavior in Mozilla Firefox prompt will always be shown
    //   //   // Chrome requires returnValue to be set
    //   e.returnValue = ''
    // })
    // window.addEventListener('beforeunload', this.confirm_leaving)
    var email = this.userInfo.user_email
    var sp = email.split('@')
    if (sp[1] === 'acsicorp.com') {
      // this.form.dept_name = this.dept_name[0]
      this.showRole = true
      this.quessclient = false

      this.getBusinessUnitList()
    } else if (sp[1] === 'quesscorp.com') {
      this.quessclient = true
    } else {
      // this.form.dept_name = this.dept_name[0]
      this.quessclient = false
    }
  },
  mounted () {
    axios.get(BaseURL + '/skills/skills/ios', this.config).then(response => {
      // console.log('success chekc')
      this.pSkils = response.data.all_skill
      this.sSkils = response.data.all_skill
      this.getDatas()
    }).catch(e => {
    })
    // this.$root.$on('message_from_abc', (arg) => {
    //   this.config = {
    //     headers: {
    //       'content-type': 'application/json',
    //       Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
    //     }
    //   }
    //   this.loaddatas()
    //   this.getPostdata(arg)
    // })
    this.$root.$on('notify', (arg) => {
      // console.log('checkl')
      this.selectpost = JSON.parse(localStorage.getItem('postId'))
      this.config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      this.querytype = arg
      this.getpostdata(this.selectpost)
      this.getDatas()
    })
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      job_tittle: {
        required,
        minLength: minLength(3)
      },
      year_of_experience: {
        required
      },
      month_of_experience: {
        required
      },
      post_validity: {
        required
      },
      primarySkils: {

      },
      secoundarySkills: {

      },
      job_interview_type: {
        required
      },
      job_description_template: {
        // required
      },
      org_description: {
        required,
        maxLength: maxLength(2000)
      },
      job_comments: {
        maxLength: maxLength(600)
      },
      client_emailid: {
        email
      },
      companyName: {

      },
      dept_name: {

      },
      businessunit_id: {

      }
    }
  },
  methods: {
    updateOtherkills () {
      axios.post(BaseURL + '/dashboard/add_others_skill_acs/' + this.selectpost + '/' + this.userInfo._id, {
        formData: this.otheremailList
      }, this.config).then(response => {
      }).catch(e => {
        console.log(e)
      })
    },
    removeerror_other () {
      this.pskillerror = false
    },
    enterEmail () {
      // console.log(this.otherEmails)
      if (this.otherEmails === '') {
        return false
      }
      this.otheremailList.push({
        skill_id: 0,
        skill_name: this.otherEmails,
        year_of_experience: 0,
        month_of_experience: 0
      })
      this.otherEmails = ''
    },
    removeEmail (index) {
      this.otheremailList.splice(index, 1)
      // console.log(this.otheremailList)
    },
    getBusinessUnitList () {
      axios.get(BaseURL + '/dashboard/get_businessunit', this.config).then(response => {
        this.businessunitlist = response.data.businessunit_list
        this.businessunitlength = response.data.businessunit_list.length
      }).catch(e => {
      })
    },
    // confirm_leaving (evt) {
    //   console.log(evt)
    //   if (this.dirty_form) {
    //     const msg = 'You have unsaved changes. Are you sure you wish to leave?'
    //     evt.returnValue = msg
    //     return msg
    //   }
    // },
    changedesc () {
      const len = this.form.org_description.length
      // console.log(len)
      if (len < 2001) {
        const cal = 2000 - len
        this.desclength = cal
      } else if (len === 2000 || len > 2000) {
        this.desclength = 0
      }
    },
    changeremarks () {
      const len = this.form.job_comments.length
      if (len < 601) {
        const cal = 600 - len
        this.remarklength = cal
      } else if (len === 600 || len > 600) {
        this.remarklength = 0
      }
    },
    changeedit () {
      // console.log('change')
      this.editoption = false
      this.editoption2 = true
      this.editoption1 = false
    },
    cancel () {
      this.editoption = true
      this.editoption2 = false
      this.editoption1 = true
    },
    updateyear () {
      // console.log(this.form.year_of_experience)
      this.topyear = this.form.year_of_experience
    },
    addZero (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    post_type_of_interview (val) {
      if (!this.editoption) {
        this.form.job_interview_type = val
      }
    },
    fileUploadss (e) {
      // console.log(e.target.files)
      $('.custom-file-upload').removeClass('is-invalid')
      for (let k = 0; k < e.target.files.length; k++) {
        if (e.target.files[k].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || e.target.files[k].type === 'application/pdf' || e.target.files[k].type === 'application/msword') {
          if (e.target.files[k].size < '2000001') {
            this.imageupload = 1
            this.files = []
            this.files.push(e.target.files[k])
          }
        }
      }
      $('#file').val('')
      // console.log(this.files)
    },
    removeUploading1 (index) {
      if (this.imageupload === 0) {
        this.deleteattachment(this.files[0].id)
      }
      this.files.splice(index, 1)
      // console.log(this.files)
    },
    uploading () {
      // console.log(this.files)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      const formData = new FormData()
      for (let k = 0; k < this.files.length; k++) {
        formData.append('image', this.files[k])
      }
      if (this.files.length > 0) {
        axios.post(BaseURL + '/dashboard/upload_post_attachment/' + this.post_id,
          formData, config).then(response => {
          // window.location.href = '/Dashboard'
        }, config).catch(e => {
          console.log(e)
        })
      }
    },
    onSubmitProfile () {
      const optionsOverrides = {
        durations: {
          global: 3000
        },
        labels: {
          success: '',
          warning: ''
        },
        position: 'bottom-right',
        icons: {
          prefix: "<i class='uil uil-exclamation-triangle'></i>",
          suffix: '',
          success: '',
          warning: '',
          enabled: true
        }
      }
      this.userInfo = JSON.parse(localStorage.getItem('user__details'))
      if (this.isclient === 'no' || this.isclient === 'No') {
        this.form.client_emailid = 'check@gmail.com'
      }
      // this.pskillsvalidation()
      if (this.validate()) {
        this.$nextTick(() => {
          if (this.isclient === 'no' || this.isclient === 'No') {
            this.form.client_emailid = ''
          }
          if (this.pvalidation === 1) {
            this.$awn.success('Select skills years and months', optionsOverrides)
            return false
          }
          axios.post(BaseURL + '/dashboard/edit_post/' + this.selectpost, {
            formData: this.form
          }, this.config).then(response => {
            const data = response.data.postInfo[0]
            // console.log(data)
            this.post_id = this.postdetails._id
            const index = this.datas.findIndex(x => x._id === data._id)
            this.datas[index].post_expired = data.post_expired
            this.post_expired = data.post_expired
            // console.log('check1')
            if (this.form.primarySkils.length > 0) {
              this.updatePrimaryskills()
            }
            if (this.otheremailList.length > 0) {
              this.updateOtherkills()
            }
            // console.log('successs')
            if (this.form.secoundarySkills.length > 0) {
              this.updateSecondarykills()
            }
            // console.log('successs1')
            if (this.imageupload === 1) {
              this.uploading()
            }
            this.getpdetails()
            // console.log('successs')
            this.editoption = true
            this.editoption2 = false
            this.editoption1 = true
            this.$awn.success('Post updated successfully')
          }).catch(e => {
          })
        })
      } else {
        console.log('validation fail................')
      }
    },
    add () {
      this.primexp = this.form.year_of_experience
      this.primmon = this.form.month_of_experience
      this.tempf = []
      const org = this.form.primarySkils.length
      const temp = this.inputs.length
      this.tempf = this.inputs
      this.inputs = []
      this.sSkils = this.pSkils
      let k = 0
      for (k = 0; k < this.form.primarySkils.length; k++) {
        // this.sSkils.splice(this.form.primarySkils[k].id, 1)
        let check = 0
        if (temp > 0 && temp < org) {
          this.tempf.forEach(item => {
            if (item.skill_id === this.form.primarySkils[k].id) {
              this.inputs.push({
                skill_id: this.form.primarySkils[k].id,
                skill_name: this.form.primarySkils[k].name,
                year_of_experience: item.year_of_experience,
                month_of_experience: item.month_of_experience
              })
              check = 1
            }
          })
        } else if (temp > 0 && temp > org) {
          var y = 0
          var m = 0
          for (let o = 0; o < this.tempf.length; o++) {
            if (this.tempf[o].skill_id === this.form.primarySkils[k].id) {
              y = this.tempf[o].year_of_experience
              m = this.tempf[o].month_of_experience
            } else {
              y = 0
              m = 0
            }
          }
          this.inputs.push({
            skill_id: this.form.primarySkils[k].id,
            skill_name: this.form.primarySkils[k].name,
            year_of_experience: y,
            month_of_experience: m
          })
          check = 1
        }
        if (check === 0) {
          // console.log(this.form.primarySkils[k].year_of_experience)
          if (this.form.primarySkils[k].year_of_experience === undefined) {
            y = 0
          } else {
            y = this.form.primarySkils[k].year_of_experience
          }
          if (this.form.primarySkils[k].month_of_experience === undefined) {
            m = 0
          } else {
            m = this.form.primarySkils[k].month_of_experience
          }
          this.inputs.push({
            skill_id: this.form.primarySkils[k].id,
            skill_name: this.form.primarySkils[k].name,
            year_of_experience: y,
            month_of_experience: m
          })
        }
        // console.log(check)
      }
    },
    addsecondaryskill () {
      // ssdds
      this.secondexp = this.form.year_of_experience
      this.secondmon = this.form.month_of_experience
      this.tempf = []
      const org = this.form.secoundarySkills.length
      const temp = this.secondaryinputs.length
      this.tempf = this.secondaryinputs
      this.secondaryinputs = []
      let k = 0
      for (k = 0; k < this.form.secoundarySkills.length; k++) {
        let check = 0
        var y = 0
        var m = 0
        if (temp > 0 && temp < org) {
          this.tempf.forEach(item => {
            if (item.skill_id === this.form.secoundarySkills[k].id) {
              this.secondaryinputs.push({
                skill_id: this.form.secoundarySkills[k].id,
                skill_name: this.form.secoundarySkills[k].name,
                year_of_experience: item.year_of_experience,
                month_of_experience: item.month_of_experience
              })
              check = 1
            }
          })
        } else if (temp > 0 && temp > org) {
          for (let o = 0; o < this.tempf.length; o++) {
            if (this.tempf[o].skill_id === this.form.secoundarySkills[k].id) {
              y = this.tempf[o].year_of_experience
              m = this.tempf[o].month_of_experience
            }
          }
          this.secondaryinputs.push({
            skill_id: this.form.secoundarySkills[k].id,
            skill_name: this.form.secoundarySkills[k].name,
            year_of_experience: y,
            month_of_experience: m
          })
          check = 1
        }
        if (check === 0) {
          if (this.form.secoundarySkills[k].year_of_experience === undefined) {
            y = 0
          } else {
            y = this.form.secoundarySkills[k].year_of_experience
          }
          if (this.form.secoundarySkills[k].month_of_experience === undefined) {
            m = 0
          } else {
            m = this.form.secoundarySkills[k].month_of_experience
          }
          this.secondaryinputs.push({
            skill_id: this.form.secoundarySkills[k].id,
            skill_name: this.form.secoundarySkills[k].name,
            year_of_experience: y,
            month_of_experience: m
          })
        }
      }
    },
    pskillsvalidation () {
      let k = 0
      this.pvalidation = 0
      this.pskillerror = false
      for (k = 0; k < this.inputs.length; k++) {
        if (!this.inputs[k].year_of_experience) {
          this.pskillerror = true
          this.pvalidation = 1
          $('#ps').focus()
        }
        if (!this.inputs[k].month_of_experience) {
          this.pskillerror = true
          this.pvalidation = 1
        }
      }
      for (let ps = 0; ps < this.showpskills.length; ps++) {
        // console.log(this.showpskills[ps].year_of_experience)
        if (!this.showpskills[ps].year_of_experience) {
          this.pskillerror = true
          this.pvalidation = 1
        } else if (this.showpskills[ps].year_of_experience > this.form.year_of_experience) {
          this.pskillerror = true
          this.pvalidation = 1
        }
      }
      for (let ss = 0; ss < this.showsskills.length; ss++) {
        if (!this.showsskills[ss].year_of_experience) {
          this.pskillerror = true
          this.pvalidation = 1
        } else if (this.showsskills[ss].year_of_experience > this.form.year_of_experience) {
          this.pskillerror = true
          this.pvalidation = 1
        }
      }
      let l = 0
      this.Sskillerror = false
      for (l = 0; l < this.secondaryinputs.length; l++) {
        if (!this.secondaryinputs[l].year_of_experience) {
          this.Sskillerror = true
          // console.log('error')
          this.pvalidation = 1
        }
        if (!this.secondaryinputs[l].month_of_experience) {
          this.Sskillerror = true
          this.pvalidation = 1
        }
      }
    },
    updateinterestcount (type, intid) {
      const id = this.userInfo._id
      axios.get(BaseURL + '/dashboard/update_notification/web/interest/' + id + '/' + this.selectpost + '/' + type, this.config).then(response => {
        this.reloaddata()
      }).catch(e => {
      })
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    checkingdate (date, end) {
      var currentDate = new Date()
      var scheduledate = moment.utc(date).format('YYYYMMDDHHmm')
      scheduledate = scheduledate - 5
      var endtime = moment.utc(end).format('YYYYMMDDHHmm')
      var currentdate = moment(String(currentDate)).format('YYYYMMDDHHmm')
      if (currentdate >= scheduledate && currentdate < endtime) {
        return 'yes'
      } else {
        return 'no'
      }
    },
    askTime (index, id, name, email) {
      // const formData = new FormData()
      // formData.append('_id', id)
      // formData.append('user_email', email)
      // formData.append('interviewer_name', name)
      // formData.append('org_name', this.userInfo.organization)
      const formData = {
        _id: id,
        user_email: email,
        interviewer_name: name,
        org_name: this.userInfo.organization
      }
      axios.post(this.base_urls + '/dashboard/send_availability_mail_acs/web', { formData: formData }, this.config).then(response => {
        this.reasonList = response.data
        // this.releventprofiles[index].availability_req_status = 'Availability Requested'
        this.getPostdata(id, 'no')
      }).catch(e => {
        // router.push({ name: 'Login' })
      })
    },
    getreasondata () {
      axios.get(this.base_urls + '/dashboard/get_cancel_reason/web', this.config).then(response => {
        this.reasonList = response.data.reasonlist
      }).catch(e => {
        router.push({ name: 'Login' })
      })
    },
    showModal (id) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.modalOpen = true
    },
    showShedule (id) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.shwovalue = true
    },
    showSheduledetails (id, status) {
      // if (status !== 'cancelled' && status !== 'Declined') {
      //   return false
      // }
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.sheduledetailsOpen = true
    },
    showReason (id) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      localStorage.setItem('reschedule', JSON.stringify('interest'))
      this.reasonOpen = true
    },
    showReason1 (id) {
      this.viewid = id
      localStorage.setItem('reschedule', JSON.stringify('cancel'))
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.reasonOpen = true
    },
    close () {
      this.intestpoput = false
      this.intestpoputre = false
      this.validationerror = false
      this.validationerrorre = false
      this.showconfirm = false
    },
    getdatetime2 (start, end) {
      this.startdatetime = start
      this.enddatetime = end
    },
    changeDate (date) {
      this.selectdate = date
      this.showtime = true
      this.groupTime(this.availabledate, this.selectdate)
    },
    groupBy (array, key) {
      const result = {}
      this.groupeddate = []
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
          this.groupeddate.push(item)
        }
      })
    },
    groupTime (array, key) {
      this.availabletime = []
      let k = 0
      for (k = 0; k < this.availabledate.length; k++) {
        if (this.availabledate[k].startdate === key) {
          this.availabletime.push(this.availabledate[k])
        }
      }
    },
    showconfirmation (id) {
      this.profileid = id
      this.showconfirm = true
    },
    getavailabledate (id, type) {
      this.actiontype = type
      this.availabledate = []
      this.groupeddate = []
      this.showtime = false
      this.profileid = id
      const mainurl = '/dashboard/get_user_availability/web/' + id
      this.intestpoput = true
      this.validationerrorre = false
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.availabledate = response.data.availabilityDetails
        this.groupBy(this.availabledate, 'startdate')
      }).catch(e => {
        console.log(e)
      })
    },
    updatePrimaryskills () {
      for (let i = 0; i < this.showpskills.length; i++) {
        this.inputs.push({
          skill_id: this.showpskills[i].id,
          skill_name: this.showpskills[i].name,
          year_of_experience: this.showpskills[i].year_of_experience,
          month_of_experience: this.showpskills[i].month_of_experience
        })
      }
      axios.post(BaseURL + '/dashboard/add_primary_skill/' + this.post_id + '/' + this.userInfo._id, {
        formData: this.inputs
      }, this.config).then(response => {
        // window.location.href = '/Dashboard'
      }).catch(e => {
        console.log(e)
      })
    },
    updateSecondarykills () {
      for (let k = 0; k < this.showsskills.length; k++) {
        this.secondaryinputs.push({
          skill_id: this.showsskills[k].id,
          skill_name: this.showsskills[k].name,
          year_of_experience: this.showsskills[k].year_of_experience,
          month_of_experience: this.showsskills[k].month_of_experience
        })
      }
      axios.post(BaseURL + '/dashboard/add_secondary_skill_edit/' + this.post_id + '/' + this.userInfo._id, {
        formData: this.secondaryinputs
      }, this.config).then(response => {
        this.getpdetails(this.selectpost)
      }).catch(e => {
        console.log(e)
      })
    },
    deleteattachment (id) {
      axios.get(BaseURL + '/dashboard/delete_post_attachment/' + id, this.config).then(response => {
      }).catch(e => {
        console.log(e)
      })
    },
    getdatetime (start, end) {
      this.startdatetime = start
      this.enddatetime = end
      this.selecttimedetais = start
    },
    reSchedule () {
      if (this.validate()) {

      } else {
        return false
      }
      let postdatas = []
      postdatas = {
        _id: this.sheduledatas._id,
        schedule_date: moment(this.selecttimedetais.startdate).format('Y-MM-DD'),
        schedule_start_time: moment('19 Oct 2017 ' + this.selecttimedetais.start_time).format('HH:mm:ss'),
        schedule_end_time: moment('19 Oct 2017 ' + this.selecttimedetais.end_time).format('HH:mm:ss'),
        start_datetime: moment(this.selecttimedetais.start_datetime).format('Y-MM-DD HH:mm:ss'),
        end_datetime: moment(this.selecttimedetais.end_datetime).format('Y-MM-DD HH:mm:ss'),
        reschedule_reason_comments: this.form.comments,
        reschedule_reason_id: this.form.reason,
        reschedule_reason_name: $('#reason option:selected').text()
      }
      const mainurl = '/dashboard/reschedule/web'
      axios.post(`${this.base_urls}${mainurl}`, { formData: postdatas }, this.config).then(response => {
        this.intestpoput = false
        this.getReleventProfile(this.selectpost, 'no')
      }).catch(e => {
        console.log(e)
      })
    },
    acceptRequest (id) {
      this.postdatas = []
      const mainurl = '/dashboard/add_org_interest/web'
      this.postdatas = {
        post_id: this.selectpost,
        user_id: this.profileid,
        org_id: this.userInfo._id,
        start_datetime: this.startdatetime,
        end_datetime: this.enddatetime
      }
      this.isLoading = true
      axios.post(`${this.base_urls}${mainurl}`, { formData: this.postdatas }, this.config).then(response => {
        this.isLoading = false
        this.loaddatas(this.selectpost)
        this.updateinterestcount('receive', this.profileid)
      }).catch(e => {
        console.log(e)
      })
    },
    loaddatas (id) {
      const mainurl = '/dashboard/get_post_interested/web/' + this.selectpost + '/send'
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.interestedsend = response.data.postDetails
        if (response.data.postDetails) {
          this.interestedsendlength = response.data.postDetails.length
        }
      }).catch(e => {
        console.log(e)
      })
      const mainurl1 = '/dashboard/get_post_interested/web/' + this.selectpost + '/receive'
      axios.get(`${this.base_urls}${mainurl1}`, this.config).then(response => {
        this.interested = response.data.postDetails
        if (response.data.postDetails) {
          this.interestedlength = response.data.postDetails.length
        }
      }).catch(e => {
        console.log(e)
      })
    },
    submitRequest (index, _id) {
      this.tempId = _id
      this.seekindex = index
    },
    seekTime (_id) {
      if (this.comments === '' || this.comments === undefined) {
        this.remarkAlert = 'Remarks is required*'
        this.submitted = false
      } else {
        this.submitted = true
        this._id = this.userInfo._id
        const formData = {
          user_id: this.tempId,
          org_id: this._id,
          comments: this.comments
        }
        axios.post(this.base_urls + '/dashboard/add_seektime', { formData: formData }, this.config).then(response => {
          this.seektimemsg = response.data.message
          if (this.seektimemsg === 'Success') {
          // this.showSeek = true
          // this.submitted = true
            $('#seekTime').modal('hide')
            // this.releventprofiles[this.seekindex].availability_req_status = ''
            this.getPostdata(this.selectpost, 'no')
          }
        }).catch(e => {
        // router.push({ name: 'Login' })
        })
      }
    },
    interestRequestEmit (data) {
      this.interestRequest(data.id, data.type)
    },
    uninterestRequestEmit (data) {
      this.profileid = data
      this.uninterestRequest(data)
    },
    interestRequest (id, type) {
      // if (this.startdatetime === '' || this.startdatetime === null || this.startdatetime === undefined) {
      //   this.validationerror = true
      //   return false
      // }
      // this.intestpoput = false
      this.postdatas = []
      const mainurl = '/dashboard/add_org_interest/web'
      this.postdatas = {
        post_id: this.selectpost,
        user_id: id,
        org_id: this.userInfo._id
        // start_datetime: this.startdatetime,
        // end_datetime: this.enddatetime
      }
      axios.post(`${this.base_urls}${mainurl}`, { formData: this.postdatas }, this.config).then(response => {
        this.updateinterestcount('sent', this.profileid)
        if (type === 1) {
          this.$awn.success('Request sent')
        } else {
          this.$awn.success('Accepted successfully')
        }
        this.loaddatas(this.selectpost)
      }).catch(e => {
        console.log(e)
      })
    },
    uninterestRequest (id) {
      this.postdatas = []
      const mainurl = '/dashboard/update_org_uninterest/web'
      this.postdatas = {
        post_id: this.selectpost,
        user_id: this.profileid,
        org_id: this.userInfo._id,
        reason_comments: '',
        reason_id: '',
        reason_name: ''
      }
      this.showconfirm = false
      axios.post(`${this.base_urls}${mainurl}`, { formData: this.postdatas }, this.config).then(response => {
        this.showconfirm = false
        this.updateinterestcount('sent', this.profileid)
        this.$awn.success('Interest cancelled')
        this.loaddatas(this.selectpost)
      }).catch(e => {
        console.log(e)
      })
    },
    getPostdata (pid, post) {
      this.getpdetails(pid)
      this.editoption1 = true
      this.editoption2 = false
      this.editoption = true
      this.inputs = []
      if (post !== 'no' && post) {
        this.job_title = post.job_tittle
        this.enableeditpost = post.enableeditpost
        this.post_unique_id = post.post_unique_id
        this.post_expired = post.post_expired
        this.job_skills = post.primaryskillnames
        this.job_validity = post.post_validity
        this.job_postedon = post.created_at
        this.selectpost = pid
        this.interest_count = post.total_interest_count
        this.receive_interest_count = post.receive_interest_count
        this.send_interest_count = post.send_interest_count
        this.client_name = post.client_name
        this.client_emailid = post.client_emailid
        this.form.businessunit_id = post.businessunit_id
        this.bull_horn_number = post.bull_horn_number
      }
      this.posttabThree = false
      this.posttabOne = true
      if (this.querytype === 'receive' || this.querytype === 'sent') {
        this.posttabThree = false
        this.posttabTwo = true
        this.posttabOne = false
        if (this.querytype === 'receive') {
          this.showfiletersend = false
          this.showfileterreceive = true
          this.getInterest(this.selectpost)
        } else {
          this.showfiletersend = true
          this.showfileterreceive = false
          this.getInterestsend(this.selectpost)
        }
      } else {
        this.posttabOne = true
        this.posttabTwo = false
      }
      let mainurl = ''
      if (this.showRole) {
        // mainurl = '/dashboard/get_relavent_profile_acs/web/' + this.selectpost
        mainurl = '/dashboard/get_relavent_profile_all_acs/web/' + this.selectpost
        axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
          this.releventprofiles = response.data.postDetails
          this.isLoading = false
        }).catch(e => {
          console.log(e)
        })
      } else {
        var datas = {
          org_emailid: this.userInfo.user_email
        }
        mainurl = '/dashboard/get_relavent_profile/web/' + this.selectpost
        axios.post(`${this.base_urls}${mainurl}`, { formData: datas }, this.config).then(response => {
          this.releventprofiles = response.data.postDetails
          this.isLoading = false
        }).catch(e => {
          console.log(e)
        })
      }
    },
    getpostdata (id) {
      const mainurl = '/dashboard/get_post_details/ios/' + id + '/' + this.userInfo._id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.selectdata = response.data.interviewerList[0]
      }).catch(e => {
        console.log(e)
      })
    },
    getpdetails (pid) {
      const mainurl = '/dashboard/get_post_details_web/' + pid
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.postdetails = response.data.postInfo[0]
        this.inputs = []
        this.secondaryinputs = []
        this.form.primarySkils = []
        this.form.secoundarySkills = []
        this.form.job_tittle = this.postdetails.job_tittle
        this.form.post_validity = this.postdetails.post_validity
        this.form.client_emailid = this.postdetails.client_emailid
        this.form.companyName = this.postdetails.client_name
        this.form.dept_name = this.postdetails.dept_name
        this.isclient = this.postdetails.isclient
        this.form.businessunit_id = this.postdetails.businessunit_id
        // $('.vdatetime-input').val(moment.utc(this.postdetails.post_validity).format('DD-MMM-YYYY'))
        this.topyear = this.postdetails.year_of_experience
        this.form.year_of_experience = this.postdetails.year_of_experience
        this.form.month_of_experience = this.postdetails.month_of_experience
        this.form.job_comments = this.postdetails.job_comments
        this.form.org_description = this.postdetails.org_description
        this.showpskills = []
        this.showsskills = []
        this.showpskills = response.data.primarySkillInfo
        this.showsskills = response.data.secondarySkillInfo
        // this.add()
        // this.addsecondaryskill()
        if (this.postdetails.job_interview_type === 'Video' || this.postdetails.job_interview_type === 'video') {
          this.form.job_interview_type = 'video'
        } else {
          this.form.job_interview_type = 'audio'
        }
        if (response.data.post_attachment.length > 0) {
          this.files = []
          this.files.push({ name: 'attachement.pdf', id: response.data.post_attachment[0]._id })
        }
        this.psskillupdates()
        this.changeremarks()
        this.changedesc()
      }).catch(e => {
        console.log(e)
      })
    },
    psskillupdates () {
      // for (let p = 0; p < this.showsskills.length; p++) {
      //   const index = this.sSkils.findIndex(item => item.id === this.showsskills[p].id)
      //   this.sSkils.splice(index, 1)
      // }
    },
    checkcounts () {
      if (this.send_interest_count < 1) {
        this.showfileterreceivesend = false
        this.getInterestsend(this.selectpost)
      } else {
        this.showfileterreceivesend = true
        this.showfiletersend = false
        this.showfileterreceive = false
      }
    },
    getInterest (pid) {
      this.selectpost = pid
      const mainurl = '/dashboard/get_post_interested/web/' + this.selectpost + '/receive'
      this.showfiletersend = false
      this.showfileterreceive = true
      this.showfileterreceivesend = false
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.interested = response.data.postDetails
        if (response.data.postDetails) {
          this.interestedlength = response.data.postDetails.length
        }
        this.updateinterestcount('receive', '1')
      }).catch(e => {
        console.log(e)
      })
    },
    getInterestsend (pid) {
      this.selectpost = pid
      const mainurl = '/dashboard/get_post_interested/web/' + this.selectpost + '/send'
      this.showfiletersend = true
      this.showfileterreceive = false
      this.showfileterreceivesend = false
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.interestedsend = response.data.postDetails
        if (response.data.postDetails) {
          this.interestedsendlength = response.data.postDetails.length
        }
        this.updateinterestcount('sent', '1')
      }).catch(e => {
        console.log(e)
      })
    },
    activeTabs () {
      this.tabOne = false
    },
    getDatas () {
      if (this.showRole) {
        if (this.postsearch) {
          this.mainurl = '/dashboard/get_interviewer_list_acs/web/' + this.postsearch + '/' + this.postsort + '/' + this.userInfo._id
        } else {
          this.mainurl = '/dashboard/get_interviewer_list_acs/web/' + "''" + '/' + this.postsort + '/' + this.userInfo._id
        }
      } else {
        if (this.postsearch) {
          this.mainurl = '/dashboard/get_interviewer_list/web/' + this.postsearch + '/' + this.postsort + '/' + this.userInfo._id
        } else {
          this.mainurl = '/dashboard/get_interviewer_list/web/' + "''" + '/' + this.postsort + '/' + this.userInfo._id
        }
      }
      // this.isLoading = true
      axios.get(`${this.base_urls}${this.mainurl}`, this.config).then(response => {
        this.datas = response.data.interviewerList
        this.isLoading = false
        if (this.$route.query.type) {
          const list = this.datas.findIndex(item => item._id === this.selectdata)
          this.getPostdata(this.selectdata, this.datas[list])
          this.selectpost = this.datas[0]._id
          this.getpdetails(this.datas[0]._id)
        } else if (this.selectdata !== 'no' && this.selectdata !== undefined && this.selectdata !== '' && this.selectdata !== null) {
          this.getPostdata(this.selectdata._id, this.selectdata)
          this.selectpost = this.selectdata._id
          this.getpdetails(this.selectdata._id)
        } else {
          if (this.datas.length > 0) {
            this.getPostdata(this.datas[0]._id, this.datas[0])
            this.selectpost = this.datas[0]._id
            this.getpdetails(this.datas[0]._id)
          }
        }
        if (!this.datas.some(data => data._id === this.selectpost)) {
          if (this.datas.length > 0) {
            this.getPostdata(this.datas[0]._id, this.datas[0])
            this.selectpost = this.datas[0]._id
            this.getpdetails(this.datas[0]._id)
          }
        }
      }).catch(e => {
        console.log(e)
      })
    },
    reloaddata () {
      if (this.showRole) {
        if (this.postsearch) {
          this.mainurl = '/dashboard/get_interviewer_list_acs/web/' + this.postsearch + '/' + this.postsort + '/' + this.userInfo._id
        } else {
          this.mainurl = '/dashboard/get_interviewer_list_acs/web/' + "''" + '/' + this.postsort + '/' + this.userInfo._id
        }
      } else {
        if (this.postsearch) {
          this.mainurl = '/dashboard/get_interviewer_list/web/' + this.postsearch + '/' + this.postsort + '/' + this.userInfo._id
        } else {
          this.mainurl = '/dashboard/get_interviewer_list/web/' + "''" + '/' + this.postsort + '/' + this.userInfo._id
        }
      }
      axios.get(`${this.base_urls}${this.mainurl}`, this.config).then(response => {
        const list = response.data.interviewerList.findIndex(item => item._id === this.selectpost)
        this.postdatas = response.data.interviewerList[list]
        // console.log(this.postdatas.receive_interest_count)
        this.interest_count = this.postdatas.total_interest_count
        this.receive_interest_count = this.postdatas.receive_interest_count
        this.send_interest_count = this.postdatas.send_interest_count
        this.datas = response.data.interviewerList
      }).catch(e => {
        console.log(e)
      })
      const mainur2 = '/dashboard/get_relavent_profile/web/' + this.selectpost
      axios.get(`${this.base_urls}${mainur2}`, this.config).then(response => {
        this.releventprofiles = response.data.postDetails
      }).catch(e => {
        console.log(e)
      })
    },
    rescheduleaccept (id) {
      console.log('show')
      axios.get(this.base_urls + '/dashboard/reschedule_accept/' + id, this.config).then(response => {
        this.getReleventProfile(this.selectpost, 'no')
      })
    },
    bothshedule () {
      const mainurl = '/dashboard/get_post_both_interest/web/' + this.selectpost
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.bothinterest = response.data.postDetails
        if (response.data.postDetails) {
          this.bothinterestlength = response.data.postDetails.length
        }
        if (this.$route.query.type === 'receive') {
          this.posttabOne = false
          this.posttabTwo = true
          this.getInterest(this.selectpost)
        }
        if (this.$route.query.type === 'sent') {
          this.posttabOne = true
          this.posttabTwo = false
          this.getInterestsend(this.selectpost)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    sheduleddata () {
      const mainurl = '/dashboard/get_schedule_user_list/web/' + this.selectpost
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.getshedule = response.data.postDetails
        if (response.data.postDetails) {
          this.getshedulelength = response.data.postDetails.length
        }
      }).catch(e => {
        console.log(e)
      })
    },
    navigation (tabs) {
      router.push({ name: tabs })
    }
  }
}
</script>

<style scoped>
.f11 {
  font-size: 11px;
}
.tabs.is-centered.is-fullwidth {
  margin-bottom: 0px;
}
ul {
    margin-bottom: 0;
    padding-bottom: 0;
}
.box___border {
  border-style: solid;
  border-width: 0px 0px 0px 0px;
  border-bottom-color: #98a2ac;
  border-right-color: #98a2ac;
  border-left-color: #98a2ac;
}
.navigation-tabs.full-pills .tabs ul {
  padding-bottom: 0px;
  border-bottom: 0px solid #fff !important;
}

.is-active {
    background-color: #fff;
}

.tabs ul li {
    text-align: center;
    padding: 9px;
    background-color: #f9f9f9;
    cursor: pointer;
}
li.green-tab.is-active {
  border-style: solid;
  border-width: 4px 0px 0px 0px;
  border-top-color: rgb(91, 173, 43);
  border-right-color: #98a2ac;
  border-left-color: #98a2ac;
}
.posttab li.green-tab.is-active {
  border-style: solid;
  border-width: 4px 0px 0px 0px;
  border-top-color: rgb(91, 173, 43);
  background: #5bad2b;
  color: #fff;
}
.flex-card .card-body.is-small {
  /* padding-right: 15px !important;
  padding-bottom: 15px !important;
  padding-left: 15px !important; */
  padding: 10px 0px;
}

.ul-padding {
  padding-top: 0px !important;
}

ol,
ul,
dl {
  margin-bottom: 0px;
}
li {
  border-bottom: 1px solid #ededed;
  border-style: solid;
  border-width: 0 0 0 4px;
  border-color: #fff;
}
.user-list li:hover {
  cursor: pointer;
  background-color: #f9f9f9;
  cursor: pointer;
  border-style: solid;
  border-width: 0 0 0 4px;
  border-color: #5BAD2B;
}
.user-list li.is-active {
  cursor: pointer;
  background-color: #f9f9f9;
  cursor: pointer;
  border-style: solid;
  border-width: 0 0 0 4px;
  border-color: #5BAD2B;
}
.pading-top-only {
  padding: 0px 18px 15px;
}
.flex-card.light-bordered.raised {
    box-shadow: none;
}
.flex-card.is-active .name {
    color: #23282c !important;
}
.view-all-btn {
  border: 1px solid #5BAD2B;
  padding: 9px;
}
.card-body li {
  border-bottom: 1px solid #ededed;
}
.view-all-btn {
    border: 1px solid #bfc1c7e8;
    padding: 5px;
}
.unintrest {
    border-color: #c8ced3;
    background-color: #ededed73 !important;
    color: #23282c !important;
}
.unintrest :hover {
  border-color: #5BAD2B;
  background-color: #5BAD2B;
  color: #fff;
}
input[type=radio]:checked + label {
  color: #f00;
  font-style: normal;
}
.posttab .tabs ul li[data-v-6e981812] {
    text-align: center;
    padding: 9px;
    background-color: #f9f9f9;
    cursor: pointer;
}
option:hover{

    background-color:white;
    color: black;

}
.img-avatar {
  width: 100%;
  height: 100%;
}
.profilename:hover {
  color:#5BAD2B;
}
@media screen and (min-width: 769px){
  .modal-content, .modal-card {
      margin: 0 auto;
      max-height: calc(100vh - 40px);
      width: 501px;
  }
}

.selectdate {
  border: 1px solid #ccc;
}
.selectdate .txt {
  font-size: 12px;
  color: #73818f !important;
}

.donate-now {
  list-style-type: none;
  margin: 25px 0 0 0;
  padding: 0;
}

.donate-now li {
  float: left;
  margin: 0 5px 0 0;
  width: 112px;
  height: 52px;
  position: relative;
}

.donate-now label,
.donate-now input {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.donate-now input[type="radio"] {
  opacity: 0.01;
  z-index: 100;
}

.donate-now input[type="radio"]:checked+label,
.Checked+label {
  background: #5bad2b;
  color:#fff;
}

.donate-now label {
  padding: 5px;
  border: 1px solid #CCC;
  cursor: pointer;
  z-index: 90;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.donate-now label:hover {
  background: #DDD;
}
.card-body li {
    border-bottom: 0px;
}
.user-list li {
  border-bottom: 1px solid #ccc;
}
.remove-pad {
  padding-right: 0px;
  padding-left: 0px;
  border-right: 1px solid #d8d7d794;
  height: auto;
  min-height: 700px;
}
.nav-tabs-custom>.tab-content {
  padding: 0px;
  margin-top: 10px;
}
a {
    color: #333;
}
.tab-content {
  background-color: white;
  height: 100% !important;
  min-height: 700px;
  display: flow-root;
}
.box-header.with-border {
    border: 1px solid #d8d7d794;
}
.filterdrop {
  height: 29px;
  font-size: 12px !important;
}
.direct-chat-msg {
    margin-bottom: 0px;
}
.btns {
  background-color: white;
  color: #5bad2b;
}
.post li a {
  line-height: 15% !important;
}
.post.nav-tabs li {
  width: auto;
}
.post li {
  border-width: 0 0 0 0px !important;
}
.nav-tabs.post>li>a:hover {
    border-color: #f5f5f5 #f5f5f5 #f5f5f5 !important;
}
.posttab ul {
  background-color: #f5f5f5 !important;
}
.post li.active a{
  background-color: #5bad2b !important;
  color: white;
  border: 0px !important;
}

.ml8 {
  margin-left: 8px !important;
}
.direct-chat-messages {
  height: auto !important;
  border-bottom: 1px solid #cccccc73;
}
.direct-chat-messages:hover {
  border-left: 3px solid #5bad2b;
  background-color: #cccccc24;
}
.mr-2 {
  margin-right: 8px;
}
.wishlist a {
  color: #999999b8 !important;
}
.register-form .row {
    margin-right: 0px !important;
    margin-left: 0px !important;
}
.modal-header {
    padding: 8px;
}
hr {
  margin-top: auto;
  margin-bottom: auto;
}
.btn-group {
  margin-right: 5px;
}
select.input-sm {
    height: 30px;
    line-height: 17px !important;
    border: 1px solid #88888840;
}
.post-empty {
  width: auto !important;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #5F2AF2;
  color: #5F2AF2;
  background-color: #fff;
  border-radius: 7px !important;
}
.modal-header {
    padding: 8px !important;
}
.box {
  box-shadow: 0 1px 1px rgb(255, 255, 255) !important;
}
.nav>li>a {
    position: relative;
    display: block;
}
.post.nav-tabs li {
    width: 33%;
}
.int-badg {
  margin-top: -7px;
  border-radius: 10px;
  background-color: #5bad2b !important;
}
.btn-success .int-badg {
  margin-top: -5px;
  border-radius: 10px;
  color: #5bad2b !important;
  background-color: #ffffff !important;
}
li.active .label-success {
  margin-top: -7px;
  border-radius: 10px;
  background-color: #ffffff !important;
  color: #5bad2b !important;
}
.nav-tabs>li>a {
    margin-right: 2px;
    line-height: 1.42857143;
    border: 1px solid transparent;
    border-radius: 0px 0px 0 0 !important;
}
.newdesign {
  color: #5bad2b !important;
  background-color: #ffffff !important;
  border: 1px solid #ffffff !important;
}
.post_interview-type {
  background-color: #5BAD2B !important;
  color: #fff !important;
  border: 1px solid #5BAD2B !important;
}
input#submit:disabled {
  background-color: #5bad2bb3 !important;
  color: #ffffff;
}
.exp-img {
  width: 13px !important;
  height: 13px !important;
  margin-left: -11px;
  margin-top: 23px;
}
.expired {
  color:#d90d01;
}
.acsli {
  width: 50% !important;
}
.txtarea{
   display: flex;
   flex-direction: column;
   justify-content: center;
 }
 .closebtnmodel{
   display: flex;
   flex-direction: row;
    justify-content: space-between;
    padding: 10px;
 }
 .myseek{
   width:100%;
   display: flex;
   flex-wrap: wrap;
   flex-direction: row;
    justify-content: flex-end;
    align-content: center;
    align-items: center;
    column-gap: 3px;
 }
 .saveaccdetialsbtn{
  background-color: #5bad2b;
  color: white;
}
</style>
